module.exports = __webpack_public_path__ + "static/assets/ddc9fae77e4b0dc8e1b094f48d1c6e18.png";